import React, { useState } from "react";
import { Button, Grid, List, ListItem, ListItemText } from "@mui/material";
import Moment from "moment";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ListItemIcon from "@mui/material/ListItemIcon";
import useScrollToTop from "../../../components/CustomHooks/useScrollToTop";

function Confirm({ prevStep, goToStep, handleConfirm, values }) {
  useScrollToTop();

  const {
    tripid,
    permitNbr,
    projectCode,
    tripType,
    portcd,
    etaTripEnd,
    gearType,
  } = values;
  // TODO: validate this date object asignment.
  const displayDate = Moment(etaTripEnd, "YYYY-MM-DD LT").format(
    "DD-MMM-YY LT"
  );
  const [isDisabled, setIsDisabled] = useState(false);

  const _next = (event) => {
    event.preventDefault();
    let new_trip_hail = {};
    const dateEnd = Moment(etaTripEnd, "YYYY-MM-DD LT").format("YYMMDDHHmm");

    if (tripType === "rsa")
      new_trip_hail = {
        est_trip_end_date: dateEnd,
        offloading_port: portcd.id,
        gear_type: gearType,
        rsa_project_code: projectCode,
      };
    else {
      new_trip_hail = {
        efp_project_code: projectCode,
      };
    }

    console.log("New Trip Hail", new_trip_hail);
    setIsDisabled(true);
    handleConfirm(new_trip_hail);
  };

  const _cancel = (event) => {
    event.preventDefault();
    if (isDisabled) {
      setIsDisabled(false);
    }
    prevStep();
  };

  const handleClick = (step) => {
    goToStep(step);
  };

  return (
    <Grid container spacing={2} justifyContent="center" alignItems="center">
      <Grid item xs={12} md={5}>
        <List>
          <ListItem style={{ paddingLeft: "7px" }} divider>
            <ListItemText primary={`Vessel Permit: ${permitNbr}`} />
          </ListItem>
          <ListItem style={{ paddingLeft: "7px" }} divider>
            <ListItemText primary={`Project Code: ${projectCode}`} />
          </ListItem>
          <ListItem style={{ paddingLeft: "7px" }} divider>
            <ListItemText primary={`Trip Type: ${tripType.toUpperCase()}`} />
          </ListItem>
          <ListItem
            button
            onClick={() => handleClick(1)}
            style={{ paddingLeft: "7px" }}
            divider
          >
            <ListItemText primary={`Trip Id: ${tripid}`} />
            <ListItemIcon style={{ minWidth: "0px" }}>
              <NavigateNextIcon />
            </ListItemIcon>
          </ListItem>
          {tripType === "rsa" && (
            <>
              <ListItem
                button
                onClick={() => handleClick(2)}
                style={{ paddingLeft: "7px" }}
                divider
              >
                <ListItemText primary={`Port: ${portcd.name}`} />
                <ListItemIcon style={{ minWidth: "0px" }}>
                  <NavigateNextIcon />
                </ListItemIcon>
              </ListItem>
              <ListItem
                button
                onClick={() => handleClick(3)}
                style={{ paddingLeft: "7px" }}
                divider
              >
                <ListItemText primary={`Gear Type: ${gearType}`} />
                <ListItemIcon style={{ minWidth: "0px" }}>
                  <NavigateNextIcon />
                </ListItemIcon>
              </ListItem>
              <ListItem
                button
                onClick={() => handleClick(4)}
                style={{ paddingLeft: "7px" }}
                divider
              >
                <ListItemText primary={`Estimated Trip End: ${displayDate}`} />
                <ListItemIcon style={{ minWidth: "0px" }}>
                  <NavigateNextIcon />
                </ListItemIcon>
              </ListItem>
            </>
          )}
        </List>
      </Grid>
      <Grid container spacing={1} justifyContent="center" alignItems="center">
        <Grid item xs="auto">
          <Button variant="contained" className="warningBtn" onClick={_cancel}>
            Back
          </Button>
        </Grid>
        <Grid item xs="auto">
          <Button
            variant="contained"
            className={isDisabled ? "disabledBtn" : "successBtn"}
            disabled={isDisabled}
            onClick={_next}
          >
            Confirm and Submit
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default Confirm;
